<template>
  <div class="success paymentResult" v-loading="loading">
    <div class="ps_box" v-if="!showDialog && showResult">
      <!-- 成功頁面 -->
      <div
        class="ps_success"
        v-if="
          $route.query.search ||
          payment.status == 'SUCCESS' ||
          payment.status == 'NOTIFIED'
        "
      >
        <img src="../../../assets/Success.png" alt="" />
        <div
          v-if="$route.meta.type === 'HZMBMORENEWPAYMENTRESULT'"
          class="result_text"
        >
          {{
            $t("message.hzmbMoRenew.payment_success", [
              serviceTypeConfig &&
                serviceTypeConfig[`name${this.$t("message.lan")}`],
            ])
          }}
        </div>
        <div
          v-else-if="$route.meta.type != 'DRV_LIC_INTER'"
          class="result_text"
        >
          {{ $t("message.DataRegistration.Taxi.payment_success") }}
        </div>
        <div v-else class="result_text">
          <span v-if="!$route.query.search">{{
            $t("message.DataRegistration.International.apply_success")
          }}</span>
          <span v-else>{{ $t("message.afterFile_success") }}</span>
        </div>
        <div class="ps_spNo">
          {{ $t("message.DataRegistration.Taxi.spNo") }}: {{ spNo }}
        </div>
      </div>
      <!-- <div class="ps_failed" v-if="payment.status == 'FAILED' || payment.status == 'CANCELLED' || payment.status == 'CLOSED'"> -->
      <!-- 錯誤頁面 -->
      <div class="ps_failed" v-else>
        <img src="../../../assets/failed.png" alt="" />
        <div class="result_text">
          <span v-if="$route.meta.type == 'TAXI_ANNUAL'">{{
            $t("message.DataRegistration.Taxi.canNotPay")
          }}</span>
          <span v-else>{{ $t("message.canNotPay") }}</span>
        </div>
        <div class="ps_spNo">
          {{ $t("message.DataRegistration.Taxi.spNo") }}: {{ spNo }}
        </div>
        <div class="failed_reason">
          <!-- <div id="preview_message">
            {{ $t("message.DataRegistration.Taxi.reason") }}xxxxxxxx
          </div> -->
          <div id="preview_message">
            {{ $t("message.DataRegistration.Taxi.failed_tips") }}
          </div>
        </div>
      </div>
      <GradientBtn style="margin-top: 24px" @click="back">{{
        $t("message.back")
      }}</GradientBtn>
    </div>

    <!-- 彈窗 -->
    <el-dialog
      :title="$t('message.pay_dialog_title')"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      width="400px"
      class="dialog_center_type trems_dialog"
      :before-close="handleClose"
    >
      <div class="way_tips_btn">
        <el-button type="primary" @click="detail">{{
          $t("message.pay_success")
        }}</el-button>
      </div>
      <div>
        {{ $t("message.closeDialog_in_seconds") }}{{ seconds
        }}{{ $t("message.closeDialog_in_seconds1") }}
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaymentAPI from "../../../api/PaymentAPI";
import ApplicationAPI from "../../../api/ApplicationAPI";
import GradientBtn from "@/components/GradientBtn.vue";
import ServiceTypeConfigAPI from "@/api/ServiceTypeConfigAPI";
export default {
  components: { GradientBtn },
  data() {
    return {
      loading: false,
      payment: {},
      sampleData: {},
      showDialog: false,
      seconds: 5,
      spNo: "",
      isFresh: true,
      showResult: false,
      serviceTypeConfig: {},
    };
  },
  watch: {
    showDialog(newVal) {
      if (newVal) {
        setInterval(() => {
          this.seconds = this.seconds - 1;
        }, 1000);
      } else {
        setTimeout(() => {
          this.seconds = 5;
        }, 1000);
        this.detail();
      }
    },
  },
  methods: {
    back() {
      this.$router.push("/");
    },
    // 查詢支付詳情
    detail() {
      // let application = {};
      // let transactionNo;
      // if (this.$route.meta.storage) {
      //   application = JSON.parse(
      //     localStorage.getItem(this.$route.meta.storage)
      //   );
      //   const spNo = application.application.spNo;
      //   this.spNo = spNo;
      //   transactionNo = application.application.applicationNo;
      // } else {
      //   transactionNo = this.$route.query.transactionNo;
      //   this.spNo = transactionNo;
      // }
      let transactionNo = this.$route.query.transactionNo;
      this.showDialog = false;
      this.loading = true;
      PaymentAPI.detail(transactionNo)
        .then((res) => {
          this.loading = false;
          this.spNo = res.spNo || res.transactionNo;
          this.showResult = true;
          this.payment = res;
          console.log("data:", res);
          // if (this.isFresh) {
          if (res.status != "SUCCESS" && res.status != "NOTIFIED") {
            setTimeout(() => {
              this.isFresh = false;
              this.detail();
            }, 5000);
          }
          // }
        })
        .catch((err) => {
          this.loading = false;
          this.showResult = true;
          this.$error(err);
        });
    },
    // 查詢簡單資料
    getSampleData() {
      const serviceType = this.$route.meta.type || null;
      const spNo = localStorage.getItem("searchSpNo") || null;
      this.spNo = spNo;
      this.loading = true;
      ApplicationAPI.getBySpNo(serviceType, spNo, "/driving")
        .then((res) => {
          this.loading = false;
          this.sampleData = res;
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    handleClose() {
      this.showDialog = false;
    },
    // 獲取服務詳情
    getConfig() {
      const serviceType = localStorage.getItem("serviceType");
      if (this.$route.meta.type === "HZMBMORENEWPAYMENTRESULT") {
        ServiceTypeConfigAPI.getDetails(serviceType)
          .then((res) => {
            if (res) {
              res[`name${this.$t("message.lan")}`] = res[
                `name${this.$t("message.lan")}`
              ].replace("\\n", "");
            }
            this.serviceTypeConfig = res;
          })
          .catch((err) => {
            this.$error(err);
          });
      }
    },
  },
  created() {
    const way = this.$route.query.way;
    const search = this.$route.query.search;
    if (search) {
      this.showResult = true;
      this.getSampleData();
    } else {
      if (way) {
        this.showDialog = false;
        this.detail();
      } else {
        this.showDialog = true;
        setTimeout(() => {
          this.showDialog = false;
        }, 5000);
      }
    }
    // 澳門配額續期，獲取服務類型詳情
    this.getConfig();
  },
};
</script>

<style lang="scss" scoped>
.success {
  height: 500px;
}
.paymentResult {
  padding-left: 15px;
  padding-right: 15px;
}
.result_text {
  font-size: 30px;
  color: #333;
  margin-bottom: 24px;
}

.ps_spNo {
  font-size: 26px;
}
.next_btn {
  padding-bottom: 0;
}
.way_tips_btn {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 30px;
}
/deep/.el-dialog {
  margin-top: 25vh !important;
}
</style>
